import { React, useEffect, useState, useRef } from 'react';
import { format, parse, isValid, startOfDay, isSameDay } from "date-fns";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import {
    Box,
    Grid,
    Stack,
    TextField,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    FormControlLabel,
    Typography,
    Chip,
    Divider,
    Button,
    Autocomplete,
    Dialog, DialogContent,
    Tooltip,
    Badge
} from "@mui/material";
import Moment from 'moment';
import { Icon } from '@iconify/react';

import SimpleTable from "../../Common/SimpleTable";
import CustomCalendar from "../../Common/CustomCalendar";
export default function ApplyForLeave({
    isManager,
    date,
    handleDate,
    remark,
    handleRemark,
    pastLeaveColumns,
    upcomingLeaveColumns,
    handleApplyForLeave,
    leaveTypeRadio,
    handleLeaveTypeRadio,
    handleDeleteDate,
    teamImpactColumns,
    leaveTypeDdl,
    setLeaveTypeDdl,
    leaveTypeOptions, handleExecutiveDdl, executiveDdl, selectedExecutiveDdl, leavePaid, setLeavePaid, leavePaidOptions, handleLongLeaveFromDate, fromDateLeave, handleLongLeaveToDate, toDateLeave, pastLeaveData, upcomingLeaveData, setSelectedDate, selectedDate, teamImpactLeaveData, projectImpactLeaveData, leaveOptions, openSuccess, setOpenSuccess, handleSuccessClose, leaveHistory, getLeaveHistory, isEditMode, isLongLeaveApprover, getHolidayList, holidayList
}) {
    const [dates, setDates] = useState([]);
    const pastLeave = [
        { id: 1, date: "27-Aug-2025", leaveDetails: "Sat-Off", status: "Approved" },
        { id: 2, date: "13-Aug-2025", leaveDetails: "Leave", status: "Approved" },
        { id: 3, date: "12-Aug-2025", leaveDetails: "HD-Post", status: "Approved" },
        { id: 4, date: "04-Aug-2025", leaveDetails: "Leave", status: "Approved" }
    ];

    const upcomingLeave = [
        { id: 1, date: "13-Sept-2025", leaveDetails: "Sat-Off", status: "Pending" },
        { id: 2, date: "22-Sept-2025", leaveDetails: "Function", status: "Pending" },
        { id: 3, date: "23-Sept-2025", leaveDetails: "Function", status: "Pending" },
        { id: 4, date: "27-Oct-2025", leaveDetails: "Sat-Off", status: "Pending" },
        { id: 5, date: "27-Oct-2025", leaveDetails: "Sat-Off", status: "Pending" },
        { id: 6, date: "27-Oct-2025", leaveDetails: "Sat-Off", status: "Pending" },
    ];

    const executiveStatusList = [
        { id: 1, executiveName: "Aditi Kadam - SAPL349", status: "Approved" },
        { id: 2, executiveName: "Pramila Khamkar - SAPL024", status: "Approved" },
        { id: 3, executiveName: "Aditi Kadam - SAPL349", status: "Approved" },
        { id: 4, executiveName: "Pramila Khamkar - SAPL024", status: "Approved" }
    ];

    const selectedDates = date || [];
    const tableMaxHeight = date?.length > 0 ? "24vh" : "60vh";

    console.log("leaveTypeOptions", leaveTypeOptions)
    console.log("selectedDates", selectedDates)
    return (
        <Box sx={{ p: 1 }}>
            <Grid container spacing={2} alignItems="flex-start">

                {/* LEFT PANEL */}
                <Grid item xs={12} md={4} sx={{
                    borderRight: "1px solid #D1D5DB", // ✅ replaces divider
                }} >
                    <Box
                        sx={{
                            height: "70vh",
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >

                        {/* SCROLLABLE AREA */}
                        <Box
                            sx={{
                                flex: 1,
                                overflowY: "auto",
                                px: 2,
                                py: 1
                            }}
                        >

                            <Stack spacing={2}>
                                {/*{isManager && (*/}
                                {isLongLeaveApprover && (

                                    <>
                                        <FormControl size="small" fullWidth>
                                            <FormLabel
                                                sx={{
                                                    mb: 0.5,
                                                    "&::after": { content: '" *"', color: "red" }
                                                }}
                                            >
                                                Select Executive
                                            </FormLabel>

                                            <Autocomplete
                                                fullWidth
                                                size="small"
                                                id="executive"
                                                options={selectedExecutiveDdl}
                                                value={
                                                    executiveDdl
                                                        ? selectedExecutiveDdl?.find(o => o.Id === executiveDdl) || null
                                                        : null
                                                }
                                                onChange={(_, newValue) => handleExecutiveDdl(newValue)}
                                                getOptionLabel={(option) => option?.Name || ""}
                                                isOptionEqualToValue={(option, value) => option.Id === value?.Id}
                                                renderInput={(params) => (
                                                    <TextField {...params} placeholder="Select Executive" />
                                                )}
                                            />
                                        </FormControl>
                                        <FormControl size="small" fullWidth>
                                            <FormLabel
                                                sx={{
                                                    mb: 0.5,
                                                    "&::after": { content: '" *"', color: "red" }
                                                }}
                                            >
                                                Leave Type
                                            </FormLabel>
                                            <Autocomplete
                                                fullWidth
                                                size="small"
                                                id="leaveType"
                                                value={leaveTypeDdl}
                                                onChange={(_, newValue) => setLeaveTypeDdl(newValue)}
                                                options={leaveOptions}
                                                getOptionLabel={(option) => option?.Name || ""}
                                                renderInput={(params) => <TextField {...params} placeholder="Select Leave Type" />}
                                                renderOption={(props, option) => (
                                                    <li {...props} key={option.Id}>
                                                        {option.Name}
                                                    </li>
                                                )}
                                            />
                                        </FormControl>
                                    </>
                                )}


                                {leaveTypeDdl?.Id === 1 && (
                                    <FormControl size="small" fullWidth sx={{ mt: 2 }}>
                                        <FormLabel
                                            sx={{
                                                mb: 0.5,
                                                "&::after": { content: '" *"', color: "red" }
                                            }}
                                        >
                                            Select Type
                                        </FormLabel>

                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="leavePaid"
                                            value={leavePaid}
                                            onChange={(_, newValue) => setLeavePaid(newValue)}
                                            options={leavePaidOptions}
                                            getOptionLabel={(option) => option?.Name || ""}
                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="Select Type" />
                                            )}
                                        />
                                    </FormControl>
                                )}

                                {/*{leaveTypeDdl?.Id === 0 && (*/}
                                {leaveTypeDdl?.Id !== 1 && (
                                    <FormControl fullWidth size="small">
                                        <FormLabel
                                            sx={{
                                                mb: 0.5,
                                                "&::after": { content: '" *"', color: "red" }
                                            }}
                                        >
                                            Select Date
                                        </FormLabel>

                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                disabled={isEditMode}
                                                value={selectedDate || null}
                                                onChange={(newDate) => {
                                                    setSelectedDate(newDate);
                                                    handleDate(newDate);
                                                }}
                                                inputFormat="dd-MM-yyyy"
                                                // shouldDisableDate={(date) => date.getDay() === 0}
                                                shouldDisableDate={(date) => {
                                                    const isSunday = date.getDay() === 0;

                                                    const isHoliday = holidayList.some((holiday) => {
                                                        const holidayDate = parse(
                                                            holiday.Date,
                                                            "dd/MMM/yyyy",
                                                            new Date()
                                                        );

                                                        return isSameDay(date, holidayDate);
                                                    });

                                                    return isSunday || isHoliday;
                                                }}
                                                onOpen={() => {
                                                    const currentDate = selectedDate || new Date();
                                                    getLeaveHistory(currentDate);
                                                    getHolidayList(currentDate);
                                                }}
                                                onMonthChange={(newMonth) => {
                                                    getLeaveHistory(newMonth);
                                                    getHolidayList(newMonth);
                                                }}
                                                renderDay={(day, _value, DayComponentProps) => {
                                                    const matchedHoliday = holidayList.find((holiday) => {
                                                        const holidayDate = parse(
                                                            holiday.Date,
                                                            "dd/MMM/yyyy",
                                                            new Date()
                                                        );

                                                        return isSameDay(day, holidayDate);
                                                    });
                                                    let matchedLeave = null;

                                                    leaveHistory.some((item) => {
                                                        const leaveDates = item.LeaveDate?.split(",").map(d => d.trim()) || [];
                                                        const leaveTypes = item.LeaveType?.split(",").map(t => t.trim()) || [];
                                                        const leaveTypeIds = item.LeaveTypeID?.split(",").map(id => Number(id.trim())) || [];

                                                        const index = leaveDates.findIndex(dateStr => {
                                                            const parsedDate = parse(
                                                                dateStr,
                                                                "dd-MMM-yyyy",
                                                                new Date()
                                                            );

                                                            return isSameDay(day, parsedDate);
                                                        });

                                                        if (index !== -1) {
                                                            matchedLeave = {
                                                                LeaveType: leaveTypes[index] || item.LeaveType,
                                                                LeaveTypeID: leaveTypeIds[index] || Number(item.LeaveTypeID)
                                                            };

                                                            return true;
                                                        }

                                                        return false;
                                                    });
                                                    const getBgColor = (leaveTypeId) => {
                                                        switch (Number(leaveTypeId)) {
                                                            case 1:
                                                                return "#ffd6d6";
                                                            case 2:
                                                                return "#dbeafe";
                                                            case 3:
                                                                return "#e9ddff";
                                                            case 4:
                                                                return "#ffe8cc";
                                                            case 5:
                                                                return "#d8f3dc";
                                                            default:
                                                                return "";
                                                        }
                                                    };

                                                    return (
                                                        <Tooltip
                                                            //  title={matchedLeave ? matchedLeave.LeaveType : ""}
                                                            title={matchedHoliday ? "Official Holiday" : matchedLeave ? matchedLeave.LeaveType : ""}

                                                        >
                                                            <span>
                                                                <PickersDay
                                                                    {...DayComponentProps}
                                                                    day={day}
                                                                    sx={{
                                                                        borderRadius: "10px",
                                                                        fontSize: "14px",
                                                                        ...(matchedHoliday && {
                                                                            backgroundColor: "#FFE8CC",
                                                                            color: "#D97706",
                                                                            fontWeight: 600,

                                                                            "&:hover": {
                                                                                backgroundColor: "#FFE8CC",
                                                                            },
                                                                        }),
                                                                        ...(!matchedHoliday &&
                                                                            matchedLeave && {
                                                                            backgroundColor: getBgColor(
                                                                                matchedLeave.LeaveTypeID
                                                                            ),
                                                                            fontWeight: 600,

                                                                            "&:hover": {
                                                                                backgroundColor: getBgColor(
                                                                                    matchedLeave.LeaveTypeID
                                                                                )
                                                                            }
                                                                        }),

                                                                        "&.Mui-selected": {
                                                                            backgroundColor: "#8B1E00 !important",
                                                                            color: "#fff"
                                                                        }
                                                                    }}
                                                                />
                                                            </span>
                                                        </Tooltip>
                                                    );
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        size="small"
                                                        placeholder={date.length === 0 ? "dd/MMM/yyyy" : ""}
                                                        sx={{
                                                            "& .MuiInputBase-input": {
                                                                opacity: 0,
                                                                width: "1px"
                                                            }
                                                        }}
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            placeholder: selectedDate
                                                                ? params.inputProps?.placeholder
                                                                : "DD-MMM-YYYY"
                                                        }}
                                                        InputProps={{
                                                            ...params.InputProps,

                                                            startAdornment: (
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        flexWrap: "wrap",
                                                                        gap: 0.5,
                                                                        alignItems: "center",
                                                                        flex: 1
                                                                    }}
                                                                >
                                                                    {selectedDates.map((d, index) => (
                                                                        <Chip
                                                                            key={index}
                                                                            size="small"
                                                                            label={
                                                                                isValid(d)
                                                                                    ? format(d, "dd-MMM-yyyy")
                                                                                    : ""
                                                                            }
                                                                            onDelete={() => handleDeleteDate(index)}
                                                                            sx={{ backgroundColor: "#ffff" }}
                                                                            disabled={isEditMode}

                                                                        />
                                                                    ))}
                                                                </Box>
                                                            ),

                                                            endAdornment: params.InputProps?.endAdornment
                                                        }}
                                                    />
                                                )}
                                                componentsProps={{
                                                    desktopPaper: {
                                                        sx: {
                                                            borderRadius: "16px",
                                                            boxShadow:
                                                                "0px 4px 20px rgba(0,0,0,0.08)",

                                                            "& .MuiPickersCalendarHeader-root": {
                                                                px: 2,
                                                                pt: 1
                                                            },

                                                            "& .MuiPickersCalendarHeader-label": {
                                                                fontSize: "18px",
                                                                fontWeight: 600
                                                            },

                                                            "& .MuiDayPicker-weekDayLabel": {
                                                                fontSize: "12px",
                                                                color: "#777"
                                                            }
                                                        }
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>

                                )}
                                {/*)}*/}

                                {leaveTypeDdl?.Id === 1 && (
                                    <Stack direction="row" spacing={2}>
                                        <FormControl fullWidth size="small">

                                            <FormLabel
                                                sx={{
                                                    mb: 0.5,
                                                    "&::after": { content: '" *"', color: "red" }
                                                }}
                                            >
                                                From Date
                                            </FormLabel>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DesktopDatePicker
                                                    inputFormat="dd/MMM/yyyy"
                                                    value={fromDateLeave ? Moment(fromDateLeave, 'DD-MMM-YYYY').toDate() : null}
                                                    onChange={handleLongLeaveFromDate}
                                                    shouldDisableDate={(date) => date.getDay() === 0}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            size="small"
                                                            {...params}
                                                            sx={{ width: 180 }}
                                                            inputProps={{
                                                                ...params.inputProps,
                                                                placeholder: fromDateLeave
                                                                    ? params.inputProps?.placeholder
                                                                    : "DD-MMM-YYYY"
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                        <FormControl fullWidth size="small">
                                            <FormLabel
                                                sx={{
                                                    mb: 0.5,
                                                    "&::after": { content: '" *"', color: "red" }
                                                }}
                                            >
                                                To Date
                                            </FormLabel>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>

                                                <DesktopDatePicker
                                                    inputFormat="dd/MMM/yyyy"
                                                    value={toDateLeave ? Moment(toDateLeave, 'DD-MMM-YYYY').toDate() : null}
                                                    onChange={handleLongLeaveToDate}
                                                    shouldDisableDate={(date) => date.getDay() === 0}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            size="small"
                                                            {...params}
                                                            sx={{ width: 180 }}
                                                            inputProps={{
                                                                ...params.inputProps,
                                                                placeholder: toDateLeave
                                                                    ? params.inputProps?.placeholder
                                                                    : "DD-MMM-YYYY"
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>

                                        </FormControl>

                                    </Stack>
                                )}
                                {/*<CustomCalendar*/}

                                {/*/>*/}

                                {/* MULTIPLE DATE CARDS */}
                                {selectedDates.length > 0 &&
                                    selectedDates.map((d, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                border: "1px solid #E5E7EB",
                                                borderRadius: "10px",
                                                p: 1.5
                                            }}
                                        >
                                            <Typography sx={{ fontSize: 12 }}>
                                                {isValid(d) && format(d, "dd-MMM-yyyy")}{" "}
                                                <Typography
                                                    component="span"
                                                    sx={{ color: "#717883", fontSize: 12 }}
                                                >
                                                    ({format(d, "EEEE")})
                                                </Typography>
                                            </Typography>

                                            <RadioGroup
                                                value={leaveTypeRadio?.[format(d, "dd-MMM-yyyy")] ?? ""}
                                                onChange={(e) => handleLeaveTypeRadio(e, d)}
                                            >
                                                <Grid container spacing={1}>
                                                    {leaveTypeOptions.map((option) => (
                                                        <Grid item xs={4} key={option.Id}>
                                                            <FormControlLabel
                                                                value={option.Id}
                                                                control={<Radio />}
                                                                label={option.Name}
                                                            />
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </RadioGroup>
                                        </Box>
                                    ))}
                                {/* REMARK */}
                                <FormControl fullWidth>
                                    <FormLabel
                                        sx={{
                                            mb: 0.5,
                                            "&::after": { content: '" *"', color: "red" }
                                        }}
                                    >Remark</FormLabel>
                                    <TextField
                                        multiline
                                        rows={3}
                                        value={remark}
                                        onChange={handleRemark}
                                        placeholder="Enter Remark"
                                    />
                                </FormControl>

                            </Stack>
                        </Box>

                        {/* APPLY BUTTON */}
                        <Box>
                            <Divider sx={{ mt: 1 }} />
                            <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1.5, px: 2 }}>
                                <Button
                                    variant="contained"
                                    sx={{ width: 200 }}
                                    onClick={handleApplyForLeave}
                                >
                                    Apply
                                </Button>
                            </Box>
                        </Box>

                    </Box>
                </Grid>
                <Dialog open={openSuccess} onClose={() => setOpenSuccess(false)}>
                    <DialogContent sx={{ textAlign: "center", p: 2, width: "288px", overflow: 'hidden' }}>
                        {/* Green check circle */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "#4caf50",
                                borderRadius: "50%",
                                width: 40,
                                height: 40,
                                mx: "auto",

                            }}
                        >
                            <Icon icon="mdi:check" color="white" width={28} height={28} />
                        </Box>

                        {/* Title */}
                        <Typography variant="h5" gutterBottom sx={{ fontSize: '24px', color: '#000000' }}>
                            Applied!
                        </Typography>

                        {/* Message */}
                        <Typography variant="body2" sx={{ mb: 2, color: '#888787', fontSize: '14px' }}>
                            Your leave has been applied successfully
                        </Typography>
                        <Button
                            variant="contained"
                            sx={{ width: 200 }}
                            onClick={handleSuccessClose}
                        >
                            Done
                        </Button>
                    </DialogContent>
                </Dialog>
                {/* RIGHT PANEL */}
                <Grid item xs={12} md={8}>
                    <Box sx={{ height: "70vh", overflowY: "auto", px: 2 }}>

                        <Grid container spacing={4}>

                            {/* Past Leaves */}
                            <Grid item xs={12} md={6}>
                                <SimpleTable
                                    title="Past Leaves"
                                    rows={pastLeaveData}
                                    columns={pastLeaveColumns}
                                    maxHeight={tableMaxHeight}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <SimpleTable
                                    title="Upcoming Applied Leaves"
                                    rows={upcomingLeaveData}
                                    columns={upcomingLeaveColumns}
                                    maxHeight={tableMaxHeight}
                                />
                            </Grid>

                            {/* TEAM IMPACT TABLES */}
                            {date?.length > 0 &&
                                date?.map((selectedDate, index) => {

                                    const formattedDate = format(selectedDate, "dd-MMM-yyyy");

                                    const filteredTeamRows = teamImpactLeaveData?.filter((item) => {
                                        if (!item.CheckDate) return false;
                                        return format(new Date(item.CheckDate), "dd-MMM-yyyy") === formattedDate;
                                    });

                                    const filteredProjectRows = projectImpactLeaveData?.filter((item) => {
                                        if (!item.LeaveDate) return false;
                                        return format(new Date(item.LeaveDate), "dd-MMM-yyyy") === formattedDate;
                                    });

                                    return (
                                        <>

                                            <Grid item xs={12} md={6}>
                                                <Box sx={{ width: "100%" }}>
                                                    <SimpleTable
                                                        title={`Team Impact (${formattedDate})`}
                                                        rows={filteredTeamRows}
                                                        columns={teamImpactColumns}
                                                        maxHeight={tableMaxHeight}
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Box sx={{ width: "100%" }}>
                                                    <SimpleTable
                                                        title={`Project Impact (${formattedDate})`}
                                                        rows={filteredProjectRows}
                                                        columns={teamImpactColumns}
                                                        maxHeight={tableMaxHeight}
                                                    />
                                                </Box>
                                            </Grid>

                                        </>
                                    );
                                })}

                        </Grid>

                    </Box>
                </Grid>

            </Grid>
        </Box>

    );
}